import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useServiceOS } from '../hooks/useServiceOS';

/**
 * Gate that determines whether to show Service OS or the full platform.
 * - Basic/Builder/Pro with onboarding_completed → Service OS
 * - Partner Pro → full platform
 * - Not onboarded → redirect to onboarding
 */
export default function SOSGate({ children, onboardingPage = false }) {
  const { user } = useAuth();
  const { getProfile } = useServiceOS();
  const [status, setStatus] = useState('loading');
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (!user) { setStatus('no_user'); return; }

    const plan = (user.plan || '').toLowerCase().replace(/[\s_-]/g, '');
    const isPartnerPro = plan === 'partnerpro' || plan === 'partner_pro';

    if (isPartnerPro) {
      setStatus('full_platform');
      return;
    }

    getProfile()
      .then(res => {
        setProfile(res.profile);
        if (res.onboarding_completed) {
          setStatus('service_os');
        } else {
          setStatus('needs_onboarding');
        }
      })
      .catch(() => setStatus('needs_onboarding'));
  }, [user, getProfile]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-[#0B0C10] flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-[#14F195] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (status === 'no_user') return <Navigate to="/login" replace />;
  if (status === 'full_platform') return <Navigate to="/dashboard" replace />;

  if (onboardingPage) {
    if (status === 'service_os') return <Navigate to="/service-os" replace />;
    return children;
  }

  if (status === 'needs_onboarding') return <Navigate to="/service-os/onboarding" replace />;
  return children;
}
